import React from 'react';

export const HoneycombLightGuardsFalse = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.4 61.8" {...props}>
    <path fill="#fff" d="M4.879.534h85.7v60.7h-85.7z" />
    <path
      d="M90.579 61.834h-85.7c-.3 0-.6-.3-.6-.6V.534c0-.3.3-.6.6-.6h85.7c.3 0 .6.3.6.6v60.7c0 .3-.3.6-.6.6zm-85.2-1.2h84.6v-59.5h-84.6v59.5z"
      fill="#dcd9d5"
    />
    <path fill="#fff" d="M4.879.534h85.7v60.7h-85.7z" />
    <path
      d="M90.579 61.834h-85.7c-.3 0-.6-.3-.6-.6V.534c0-.3.3-.6.6-.6h85.7c.3 0 .6.3.6.6v60.7c0 .3-.3.6-.6.6zm-85.2-1.2h84.6v-59.5h-84.6v59.5z"
      fill="#dcd9d5"
    />
    <g fill="#dcd9d5">
      <path d="M8.879 4.534h77.7v52.7h-77.7z" />
      <path d="M86.579 57.834h-77.7c-.3 0-.6-.3-.6-.6v-52.7c0-.3.3-.6.6-.6h77.7c.3 0 .6.3.6.6v52.7c0 .3-.3.6-.6.6zm-77.2-1.2h76.6v-51.5h-76.6v51.5z" />
    </g>
    <path
      d="M94.879 61.734H.479c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h94.4c.3 0 .5.2.5.5.1.3-.2.5-.5.5z"
      fill="#dcd9d5"
    />
    <g>
      <path fill="#929497" d="M7.9 3.4h79.3v3.3H7.9z" />
      <path
        d="M87 3.6v2.8H8.2V3.6H87m.5-.4H7.7V6.8H87.4V3.2h.1z"
        fill="#fff"
      />
      <path fill="#929497" d="M7.9 36.2h79.4v1.7H7.9z" />
      <path
        d="M87.1 36.4v1.4H8v-1.4h79.1m.4-.3H7.7v2H87.4v-2h.1z"
        fill="#fff"
      />
      <path fill="#929497" d="M9.1 6.9h77v2.7h-77z" />
      <path
        d="M85.9 7.1v2.3H9.3V7.1h76.6m.4-.4H8.9V9.8H86.2V6.7h.1z"
        fill="#fff"
      />
      <path fill="#929497" d="M9.1 12.6V9.9h77v2.7z" />
      <path
        d="M85.9 10.1v2.3H9.3v-2.3h76.6m.4-.4H8.9V12.8H86.2V9.7h.1z"
        fill="#fff"
      />
      <g>
        <path fill="#929497" d="M9.1 12.7h77v2.7h-77z" />
        <path
          d="M85.9 12.9v2.3H9.3v-2.3h76.6m.4-.4H8.9V15.6H86.2V12.5h.1z"
          fill="#fff"
        />
        <g>
          <path fill="#929497" d="M9.1 18.4v-2.7h77v2.7z" />
          <path
            d="M85.9 16v2.3H9.3V16h76.6m.4-.5H8.9V18.6H86.2v-3.1h.1z"
            fill="#fff"
          />
        </g>
      </g>
      <g>
        <path fill="#929497" d="M9.1 18.6h77v2.7h-77z" />
        <path
          d="M85.9 18.8v2.3H9.3v-2.3h76.6m.4-.4H8.9V21.5H86.2V18.4h.1z"
          fill="#fff"
        />
        <g>
          <path fill="#929497" d="M9.1 24.3v-2.7h77v2.7z" />
          <path
            d="M85.9 21.9v2.3H9.3v-2.3h76.6m.4-.5H8.9V24.5H86.2V21.4h.1z"
            fill="#fff"
          />
        </g>
      </g>
      <g>
        <path fill="#929497" d="M9.1 24.5h77v2.7h-77z" />
        <path
          d="M85.9 24.7V27H9.3v-2.3h76.6m.4-.5H8.9V27.3H86.2V24.2h.1z"
          fill="#fff"
        />
        <g>
          <path fill="#929497" d="M9.1 30.2v-2.7h77v2.7z" />
          <path
            d="M85.9 27.7V30H9.3v-2.3h76.6m.4-.4H8.9V30.4H86.2V27.3h.1z"
            fill="#fff"
          />
        </g>
      </g>
      <g>
        <path fill="#929497" d="M9.1 30.2h77v2.7h-77z" />
        <path
          d="M85.9 30.4v2.3H9.3v-2.3h76.6m.4-.4H8.9V33.1H86.2V30h.1z"
          fill="#fff"
        />
        <g>
          <path fill="#929497" d="M9.1 35.9v-2.7h77v2.7z" />
          <path
            d="M85.9 33.4v2.3H9.3v-2.3h76.6m.4-.4H8.9V36.1H86.2V33h.1z"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
  );
};
